
function validate({ lang = [] }) {
  const currentLanguage = game.models.GameModel.I18n.split('-')[0].toLowerCase()
  const isAccessed = lang && !lang.every((item) => item.includes('!'))

  return isAccessed
    ? lang.some((item) => item.includes(currentLanguage))
    : !lang.some((item) => item.includes(currentLanguage))
}

export const Language = { validate }
